<template>
  <div style="display: block;" id="upload-avatar">
    <mu-row align="left" style="align-items: center;">
      <mu-col desktop="10" tablet="15" width="20"  v-if="!hideAvatar && $store.state.user.scope.profile_large" >
        <mu-avatar
          style="height: 50px; width: 50px"
          :src="$store.state.user.scope.profile_large ? $store.state.user.scope.profile_large : 'static/avatar.png'"
        />
      </mu-col>
      <mu-col desktop="90" tablet="85" width="80" align="left"  v-if="!hideAvatar">
        <mu-flat-button
          style="margin-left: 8px;"
          v-if="!isSaving"
          icon="add_a_photo"
          @click.native="openInput()"
          :label="$store.state.user.scope.profile_large === null ?  'Upload avatar' : $t('message.accountPreferencesChangeAvatar')"
        ></mu-flat-button>
        <mu-col v-if="isSaving" style="align-items: center">
          <mu-circular-progress
            style="margin-left: 16px;"
            :size="16"
          ></mu-circular-progress>
          <span style="display: inline-flex; margin-left: 8px;">
               Uploading picture
          </span>
        </mu-col>
      </mu-col>
    </mu-row>
    <br/>
    <vue-base64-file-upload
      disable-preview
      placeholder="Click to change profile pic"
      accept="image/png,image/jpeg"
      :max-size="customImageMaxSize"
      @size-exceeded="onSizeExceeded"
      @load="onLoad"
    ></vue-base64-file-upload>
    <div v-show="isImagePresent">
      <div ref="imageCropper"></div>
      <mu-content-block v-if="isSaving" align="center">
        <mu-circular-progress></mu-circular-progress>
        <br/>
        <div>Uploading...</div>
      </mu-content-block>
      <mu-card-actions v-show="isImagePresent" align="center" v-if="!isSaving">
        <mu-icon-button
          tooltip="Cancel"
          icon="close"
          v-if="!isSaving"
          label="Cancel"
          @click.native="doCancel()"
        ></mu-icon-button>
        <mu-icon-button
          tooltip="Rotate left"
          icon="rotate_left"
          @click.native="rotate('left')"
        ></mu-icon-button>
        <mu-icon-button
          tooltip="Rotate right"
          icon="rotate_right"
          @click.native="rotate('right')"
        ></mu-icon-button>
        <mu-circular-progress :size="16" v-show="isSaving"></mu-circular-progress>
        <mu-raised-button
          secondary
          icon="crop"
          :label="isSaving ? 'Uploading...': 'Save profile picture'"
          @click.native="doCrop()"
        ></mu-raised-button>
      </mu-card-actions>
    </div>
  </div>
</template>
<script>


  import Croppie from 'croppie'
  import 'croppie/croppie.min.js'





  import VueBase64FileUpload from 'vue-base64-file-upload';
  import Profile from '../../api/Profile'

  export default {
    components: {
      VueBase64FileUpload
    },
    props: {
      hideAvatar: {
        type: Boolean,
        required: false,
      },
      imageUrl: {
        type: String,
        required: false,
      }
    },
    name: 'avatar-uploader',
    data() {
      return {
        isSaving: false,
        customImageMaxSize: 2,
        src: "",
        image: "",
        loading: true,
        user: {},
        cropper: undefined,
        isImagePresent: false,
        snackbar: false
      }
    },
    mounted() {
      let self = this;
      const wait = setTimeout(function () {
        const el = self.$refs['imageCropper'];
        if(el) {
          if(self.imageUrl) {
            self.initCropper(el);
            self.cropper.bind({
              url: self.imageUrl,
              orientation: 1
            });
            self.isImagePresent = true;
          } else {
            self.initCropper(el);
            self.cropper.bind({
              url: 'static/avatar.png',
              orientation: 1
            });
          }
        }
        clearTimeout(wait);
      }.bind(self), 500)
    },
    created() {
      let self = this;
    },
    methods: {
      openInput() {
        let self = this;
        $('.vue-base64-file-upload-wrapper input').click()
      },
      doCancel() {
        let self = this;
        self.isImagePresent = false;
        self.$emit('destroyUploader', null);
      },
      onLoad(dataUri) {
        let self = this;
        self.image = dataUri;
        self.cropper.bind({
          url: dataUri
        });
        self.isImagePresent = true;
      },
      onSizeExceeded(size) {
        alert(`Image ${size}Mb size exceeds limits of ${this.customImageMaxSize}Mb!`);
      },
      doCrop() {
        let self = this;
        self.isSaving = true;
        self.isImagePresent = false;
        self.$forceUpdate();
        $('.main-content').animate({
          scrollTop: $("#upload-avatar").offset().top
        }, 300);
        self.cropper.result('base64')
          .then(function (image) {
            Profile.changeProfilePicture(image)
              .then(function (response) {

                if(_.has(self.$store.state.activeProfileObject, 'information')){
                  self.$store.state.activeProfileObject.information.basic.profile_image = response.data.profile_large;
                }

                self.isSaving = false;
                self.$toastr.success("Updated profile picture");
                self.$emit('destroyUploader', null);
              })
          })
      },
      rotate(direction) {
        let self = this;
        if (direction === 'left') {
          self.cropper.rotate(-90)
        }
        if (direction === 'right') {
          self.cropper.rotate(90);
        }
      },
      initCropper(el) {
        let self = this;
        self.cropper = new Croppie(el, {
          viewport: {width: 200, height: 200},
          boundary: {width: 250, height: 250},
          showZoomer: true,
          enableOrientation: true
        });
      }
    },
    computed: {
      upperTwoInitials: {
        get() {
          let self = this;
          return self.$store.state.user.scope.display_name && self.$store.state.user.scope.use_display_name ?
            self.$store.state.user.scope.display_name.charAt(0).toUpperCase() + self.$store.state.user.scope.display_name.charAt(1).toUpperCase() :
            self.$store.state.user.scope.firstname.charAt(0).toUpperCase() + self.$store.state.user.scope.surname.charAt(0).toUpperCase();
        }
      }
    },
    beforeDestroy() {
      let self = this;
      if (self.cropper !== undefined) {
        self.cropper.destroy();
      }
    }
  }
</script>
<style>
  @import "./upload-avatar.css";
</style>



// WEBPACK FOOTER //
// UploadAvatar.vue?038464a4